export const OVERPASS_URL = "https://overpass-api.de/api/interpreter";
export const API_SNCF_URL = "https://api.navitia.io/v1/coverage/sncf";
export const OPEN_DATA_SCNF_URL = "https://ressources.data.sncf.com/api/records/1.0/search";
export const OPENROUTESERVICE_URL = "https://api.openrouteservice.org";
 
export const PHOTON_SEARCH_URL = "https://photon.komoot.de/api/?q=";
export const PHOTON_REVERSE_URL = "https://photon.komoot.de/reverse?";
 
// export const FRIENDS_LOCALIZATION_URL = "http://127.0.0.1:9090/findfriends";
export const FRIENDS_LOCALIZATION_URL = "https://biketrainmap.fabzi.fr/findfriends";